/**
* this displays the add fund page
*
* Created by Paul on 17/6/19
*/

import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import cx from 'classnames'
import { connect } from 'react-redux'
import { Field, reduxForm, FormSection, FieldArray } from 'redux-form'

// action import
import { ActionCreator } from '../../actions/'

// component import
import AppLink from '../../components/AppLink'

// Configurations
import constants from '../../constants'

// material-ui import
import { withStyles, makeStyles } from '@material-ui/styles'
import compose from 'recompose/compose'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'

import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepContent from '@material-ui/core/StepContent'
import StepLabel from '@material-ui/core/StepLabel'
import Button from '@material-ui/core/Button'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from "@material-ui/core/Checkbox"
import FormHelperText from '@material-ui/core/FormHelperText'
import CircularProgress from '@material-ui/core/CircularProgress'

import DatePicker from '@material-ui/pickers'

import config from '../../config'

// style import
import './style.scss'

// data import
import { getOccupations, getOccupationSubTypes } from './occupations'
import { getCountries} from './countries'

const styles = theme => ({
    gridroot: {
        flexGrow: 1,
        marginBottom: 30,
        marginLeft: 10,
    },
    memberRoot: {
        flexGrow: 1,
        marginBottom: 30,
        marginLeft: 10,
        marginTop: 20,
    },
    title: {
        fontWeight: 500,
        fontSize: 16,
        marginTop: 15,
        marginLeft: 15,
    },
    subTitle: {
        marginLeft: 15,
    },
    footer: {
        fontSize: 14,
        marginLeft: 15,
    },
    stepRoot: {
        width: '100%',
    },
    button: {
        marginRight: 10,
        boxShadow: 'none',
    },
    instructions: {
        marginTop: 10,
        marginBottom: 10,
    },
    textField: {
        width: '100%',
        marginTop: 4,
        marginBottom: 0,
        fontSize: 10,
    },
    cardRoot: {
        height: '100%',
    },
    cardContent: {
        '&:last-child': {
            paddingBottom: 16,
        }
    },
    formControl: {
        width: '100%',
    },
    memberTitle: {
        paddingTop: 10,
        paddingBottom: 5,
    },
    removeLink: {
        fontSize: 11,
    },
    progressButton: {
        backgroundColor: "transparent",
        "&:hover": {
            backgroundColor: "transparent",
            cursor: 'default'
        }
    },
    highlight: {
        fontWeight: 600,
    },
})

const renderTextField = ({
    label,
    input,
    meta: { touched, invalid, error },
        ...custom
    }) => (
        <TextField
            label={label}
            placeholder={label}
            error={invalid}
            helperText={error}
            margin="dense"
            {...input}
            {...custom}
        />
)

const renderDatePicker = ({
    label,
    input,
    meta: { touched, invalid, error },
        ...custom
    }) => (
        <TextField
            id="date"
            label={label}
            error={invalid}
            type="date"
            {...input}
            {...custom}
        />
)

const renderCheckbox = ({ input, label }) => (
    <FormControlLabel
        control={
            <Checkbox
            checked={input.value ? true : false}
            onChange={input.onChange}
            color="primary"
            />
        }
        label={label}
    />
)

const renderSelectField = ({
    input,
    label,
    classes,
    meta: { touched, error, invalid },
    children,
    ...custom
}) => (
    <FormControl error={invalid} className={classes.formControl}>
        <InputLabel htmlFor="drop-down-select">{label}</InputLabel>
            <Select
                {...input}
                {...custom}
                inputProps={{
                    id: 'drop-down-select'
                }}
            >
                {children}
            </Select>
        { renderFromHelper({ invalid, error }) }
    </FormControl>
)

const renderFromHelper = ({ invalid, error }) => {
    if (!(invalid)) {
       return
    } else {
        return <FormHelperText>{error}</FormHelperText>
    }
}

class FundAdd extends Component {

    constructor(props) {
        super(props)
        this.handleNext = this.handleNext.bind(this)
        this.handleBack = this.handleBack.bind(this)
        this.handleFundTypeChange = this.handleFundTypeChange.bind(this)
        this.removeMember = this.removeMember.bind(this)
        this.handleTermsChange = this.handleTermsChange.bind(this)
        
        this.state = {
            companyName: '',
            fundType: '',
            jurisdiction: '',
            fundName: '',
            selfmadeTerms: false,
            transactionTerms: false,
            debitTerms: false,
            abn: '',
            acn: '',
            occupationOptions: [[],[],[],[]]
        }
    }

    componentDidMount() {

        const { member_id } = this.props.match.params
        
        const { fetchInProgressFund, clearFundForm, setActiveStep } = this.props

        clearFundForm()

        if (member_id) {
            fetchInProgressFund(member_id)
        }
        else {
            setActiveStep(0)
        }
    }

    handleChange = field => (event) => {
        this.setState({ [field]: event.target.value })
    }

    getSteps() {
        return ['Primary Account Details', 'Fund Structure', 'Fund Members', 'Review Fund']
    }

    getStates() {
        return ["TAS", "VIC", "NSW", "QLD", "NT", "SA", "WA", "ACT"]
    }

    getLongStates() {
        return ['Australian Capital Territory', 'Tasmania', 'Victoria', 'New South Wales', 'Queensland', 'Northern Territory', 'South Australia', 'Western Australia']
    }

    getFundTypes() {
        return ['Individual', 'Corporate']
    }

    getTitles() {
        return ['Mr', 'Ms', 'Miss', 'Mrs', 'Dr']
    }

    handleNext() {
        const { activeStep, setActiveStep } = this.props
        setActiveStep(activeStep + 1)
    }

    handleBack() {
        const { activeStep, setActiveStep } = this.props
        setActiveStep(activeStep - 1)
    }

    render() {

        const { classes, handleSubmit, activeStep, fundFormData } = this.props
        const steps = this.getSteps()

        return (
            <div className="funds main-wrapper">
                <Card raised className={classes.cardRoot}> 
                    <CardContent className={classes.cardContent}>

                        <Typography className={classes.title} variant="h5" component="h2">
                            Establish / Transition a Self Managed Super Fund
                        </Typography>

                        <Typography className={classes.subTitle} variant="body1" color="textSecondary" component="p">
                            The process can be resumed at anytime
                        </Typography>
                        
                        <div className={classes.stepRoot}>
                            <form
                                className="fund-form"
                                onSubmit={handleSubmit(::this.handleSaveAndContinue)}
                            >
                            
                                <Stepper activeStep={activeStep} orientation="vertical">
                                    
                                    <Step>
                                        <StepLabel>{steps[0]}</StepLabel>
                                        <StepContent>
                                            
                                            { this.renderFundAccountFields() }

                                            { this.renderStepActions() }
                                            
                                            
                                        </StepContent>
                                    </Step>

                                    <Step>
                                        <StepLabel>{steps[1]}</StepLabel>
                                        <StepContent>
                                            
                                            { this.renderFundStructureFields() }

                                            { this.renderStepActions() }
                                            
                                        </StepContent>
                                    </Step>

                                    <Step>
                                        <StepLabel>{steps[2]}</StepLabel>
                                        <StepContent>


                                            <FieldArray name="members" component={this.renderMemberFields} />

                                            { this.renderStepActions() }

                                        </StepContent>
                                    </Step>

                                    <Step>
                                        <StepLabel>{steps[3]}</StepLabel>
                                        <StepContent>
                                            
                                            { this.renderTermsAndConditions() }

                                            { this.renderStepActions() }
                                            
                                        </StepContent>
                                    </Step>
                                    
                                </Stepper>
                            </form>

                            { activeStep === steps.length && (

                                <div>
                                    <Typography variant="h6" color="textPrimary" component="div" className={classes.footer}>
                                        The fund <strong>{fundFormData.fund_name}</strong> has been successfully submitted to Selfmade for processing.
                                    </Typography>
                                </div>

                            )}

                        </div>

                    </CardContent>

                </Card>
            </div>
        )
    }


    renderStepActions() {

        const { classes, isSubmitting, activeStep, initialValues, dirty, fundFormData, fundStatus } = this.props
        const steps = this.getSteps()

        return (
            <div className={classes.actionsContainer}>
                <div>
                    <Button
                        size="small"
                        disabled={activeStep === 0}
                        onClick={this.handleBack}
                        className={classes.button}
                        variant="contained"
                        >
                        Back
                    </Button>
                    {/*
                    <Button
                        size="small"
                        type="submit"
                        variant="outlined"
                        disabled={!dirty}
                        className={classes.button}
                        >  
                        Save
                    </Button>
                    */}
                    { activeStep === 2 &&
                        <Button
                            size="small"
                            variant="contained"
                            disabled={Object.keys(fundFormData.members).length === 4}
                            className={classes.button}
                            onClick={() => this.props.array.push('members', { 'occupationOptions': [] })}
                        >    
                            Add Optional Member
                        </Button>
                    }
                    
                    { (!initialValues.id || (initialValues.id && activeStep == 2)) &&
                        <Button
                            size={((activeStep == 2 && (dirty || !fundStatus)) || !fundStatus) ? "medium" : "small"}
                            variant="contained"
                            color="primary"
                            type="submit"
                            className={classes.button}
                            disabled={activeStep == 2 && (!dirty && fundStatus)}
                            >
                                Save and Continue
                        </Button>
                    }

                    { initialValues.id && (activeStep < 3) &&
                        <Button
                            size={(activeStep == 2 && (dirty || !fundStatus)) ? "small" : "medium"}
                            variant="contained"
                            color="primary"
                            onClick={this.handleNext}
                            className={classes.button}
                            disabled={(activeStep == 2 && (dirty || !fundStatus))}
                            >
                                Next
                        </Button>
                    }

                    { activeStep === 3 &&
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            disabled={(!fundFormData.agree_terms_and_conditions && !fundFormData.agent_agree_terms_and_conditions) || isSubmitting}
                            >
                                Submit Fund
                        </Button>
                    }

                    { isSubmitting &&
                        <Button className={classes.progressButton}>
                            <CircularProgress
                                size={24}
                                thickness={4}
                            />
                        </Button>
                    }
                    
                </div>
            </div>
        )

    }

    /* Individual Funds must have 2 - 4 members, a Corporate Fund can be 1 - 4 members
       If switch to individual and only a single member, add and enforce another member
       If switch to corporate and the second member is not populated, remove second member */
    handleFundTypeChange(event) {
        
        const { fundFormData } = this.props
        
        this.setState({ fundType: event.target.value })

        if (event.target.value === 'Individual') {
            if (Object.keys(fundFormData.members).length === 1) {
                this.props.array.push('members', { 'occupationOptions': [] })
            }
        }
        else {
            if (Object.keys(fundFormData.members).length === 2 && !(fundFormData.members[1].first_name || fundFormData.members[1].last_name || fundFormData.members[1].title || fundFormData.members[1].email)) {
                this.props.array.pop('members')
            }
        }
    }

    createBlankMember() {
        let member = {
            not_use_residential_as_mailing: true,
            occupationOptions: [],
        }

        return member
    }

    removeMember() {
        this.props.array.pop('members')
    }

    handleTermsChange(type) {
        this.setState({ [type]: !this.state[type] })
    }

    renderTermsAndConditions() {
        
        const { classes, fundFormData, fundsSummaryData } = this.props

        let isAgent = fundsSummaryData['administrator_type'].startsWith('agent-')
        
        return (
            <div className={classes.gridroot}>
                
                <div className="terms-container">
                    
                    <Typography variant="h6" color="textPrimary" component="div" className={classes.memberTitle}>
                        Ready to submit to Selfmade for establishment
                    </Typography>

                    <Typography variant="body2" color="textSecondary" component="p" gutterBottom>
                        The fund has been saved and can be left in this 'review' state until you are ready to submit to Selfmade.
                    </Typography>

                    <br />

                    { isAgent ? (
                            <React.Fragment>
                                
                                <Field
                                    name="agent_agree_terms_and_conditions"
                                    component={renderCheckbox}
                                    label="Agent Representation and Warranty"
                                />

                                <Typography variant="body2" color="textSecondary" component="p">
                                    I represent and warrant to Selfmade that I have the permission and authority to provide the clients details to Selfmade. I understand and agree that Selfmade has not recommended the establishment of a self-managed superannuation fund to either the Agent, their client(s) or to any trustee(s) or member(s) of the proposed SMSF. The agent represents and warrants to Selfmade that it has complied in all respects with its obligation within the Agent Portal Access Agreement.
                                </Typography>

                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <Field
                                    name="agree_terms_and_conditions"
                                    component={renderCheckbox}
                                    label="Agree to Selfmade Terms and Conditions"
                                />

                                <Typography variant="body2" color="textSecondary" component="p" gutterBottom>
                                    I make the following declarations on my own behalf as the Adviser and at the direction of 
                                    each trustee and member of the proposed self-managed superannuation fund ("SMSF"). I have 
                                    read and understood the Selfmade Super Financial Services Pty Ltd 
                                    (“Selfmade”)&nbsp;
                                    <AppLink
                                        route={config.endpoints.websiteTermsURL}
                                        isExternal={true}
                                        openInNewTab={true}>
                                        Terms & conditions
                                    </AppLink>
                                    &nbsp;(which include the Selfmade&nbsp;
                                    <AppLink
                                        route={config.endpoints.websitePrivacyPolicyURL}
                                        isExternal={true}
                                        openInNewTab={true}>
                                        Privacy policy
                                    </AppLink>
                                    &nbsp;).
                                </Typography>

                                <Typography variant="body2" color="textSecondary" component="p" gutterBottom>
                                    I understand and agree that Selfmade has not recommended the establishment of a self-managed 
                                    superannuation fund (“SMSF”) to the Adviser or to any trustee or member of the proposed SMSF.
                                </Typography>

                                <Typography variant="body2" color="textSecondary" component="p">
                                    I understand and acknowledge that Selfmade (or its nominated tax 
                                    agent entity) will be appointed as the taxation agent for the 
                                    SMSF and that tax agent entity may elect to receive correspondence 
                                    directly from the ATO in relation to the SMSF.
                                </Typography>
                            </React.Fragment>
                        )
                    }

                    

                </div>

            </div>
        )
    }

    getOccupationSubTypes(member) {
        if (member.occupation_type) {
            return getOccupationSubTypes(member.occupation_type)
        }
        else {
            return []
        }
    }

    // Provides a non-form array embedded agaisnt the member for the occupation sub-type look-up
    handleSelectOccupationType = index => (event) => {        
        this.props.change(`members[${index}].occupation_category`, null)
    }

    renderMemberFields = ({ fields, meta: { error } }) => {

        const { classes, fundFormErrors, fundFormData, rawFormData } = this.props

        return (
            fields.getAll().map((member, index) => (
                <div key={index} className={classes.gridroot}>
                        
                    <Typography variant="body1" color="textPrimary" component="div" className={classes.memberTitle}>
                        Member & {fundFormData.fund_type === 'Corporate' ? 'Director' : 'Trustee'} {index + 1} { (index > 1 || (index === 1 && fundFormData.fund_type === 'Corporate')) && <span> - <a href="#" onClick={() => this.removeMember(index)} variant="body2" className={classes.removeLink}>(Remove Member)</a></span> }
                    </Typography>

                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Field
                                name={`members[${index}].title`}
                                component={renderSelectField}
                                label="Title"
                                classes={classes}
                            >
                                { this.getTitles().map((type, index) => {return (<MenuItem key={index} value={type}>{type}</MenuItem>)}) }
                            </Field>
                        </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Field name={`members[${index}].first_name`} disabled={index === 0} component={renderTextField} label="First Name" className={classes.textField} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Field name={`members[${index}].middle_name`} component={renderTextField} label="Middle Name" className={classes.textField} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Field name={`members[${index}].last_name`} disabled={index === 0} component={renderTextField} label="Last Name" className={classes.textField} />
                        </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Field name={`members[${index}].email`} disabled={index === 0} component={renderTextField} label="Email" className={classes.textField} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Field name={`members[${index}].phone`} disabled={index === 0} component={renderTextField} label="Phone" className={classes.textField} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <Field name={`members[${index}].date_of_birth`} component={renderDatePicker} label="Date of Birth" className={classes.textField} InputLabelProps={{shrink: true }} />
                        </Grid>
                    </Grid>

                    { fundFormData.fund_type === 'Corporate' && fundFormData.fund_origin === 'NEW' &&
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6} md={4}>
                                <Field
                                    name={`members[${index}].country_of_birth`}
                                    component={renderSelectField}
                                    label="Country of Birth"
                                    classes={classes}
                                >
                                    { getCountries().map((country, index) => {return (<MenuItem key={ index } value={country}>{country}</MenuItem>)}) }
                                </Field>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Field
                                    name={`members[${index}].state_of_birth`}
                                    disabled={fundFormData.members[index].country_of_birth != 'Australia'}
                                    component={renderSelectField}
                                    label="State of Birth"
                                    classes={classes}
                                >
                                    { this.getLongStates().map((state, index) => {return (<MenuItem key={ index } value={state}>{state}</MenuItem>)}) }
                                </Field>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <Field name={`members[${index}].city_of_birth`} component={renderTextField} label="Town / City of Birth" className={classes.textField} />
                            </Grid>
                        </Grid>
                    }

                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Field name={`members[${index}].tfn`} component={renderTextField} label="Tax File Number" className={classes.textField} />
                        </Grid>

                        { fundFormData.fund_origin === 'NEW' &&
                            <Fragment>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Field
                                        name={`members[${index}].occupation_type`}
                                        component={renderSelectField}
                                        label="Occupation Type"
                                        classes={classes}
                                        onChange={this.handleSelectOccupationType(index)}
                                    >
                                        { getOccupations().map((occupationType, index) => {return (<MenuItem key={ index } value={ occupationType }>{ occupationType }</MenuItem>)}) }
                                    </Field>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Field
                                        name={`members[${index}].occupation_category`}
                                        component={renderSelectField}
                                        label="Occupation Category"
                                        classes={classes}
                                    >
                                        { this.getOccupationSubTypes(fundFormData.members[index]).map((occupationSubType, index) => {return (<MenuItem key={ index } value={ occupationSubType }>{ occupationSubType }</MenuItem>)}) }
                                    </Field>
                                </Grid>
                            </Fragment>
                        }
                    </Grid>

                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Field name={`members[${index}].residential_address`} component={renderTextField} label="Residential Address" className={classes.textField} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <Field name={`members[${index}].residential_unit`} component={renderTextField} label="Unit # (Optional)" className={classes.textField} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <Field name={`members[${index}].residential_suburb`} component={renderTextField} label="Suburb" className={classes.textField} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <Field
                                name={`members[${index}].residential_state`}
                                component={renderSelectField}
                                label="State"
                                classes={classes}
                            >
                                    { this.getStates().map((state, index) => {return (<MenuItem key={ index } value={state}>{state}</MenuItem>)}) }
                            </Field>
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <Field name={`members[${index}].residential_postcode`} component={renderTextField} label="Postcode" className={classes.textField} />
                        </Grid>
                    </Grid>

                    { index === 0 &&
                        <div className="postal-residential-container">
                            <Field name={`members[${index}].not_use_residential_as_mailing`} component={renderCheckbox} label="Postal address is different to residential?" />
                        </div>
                    }

                    { index === 0 && fundFormData.members[0].not_use_residential_as_mailing &&
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6} md={4}>
                                <Field name={`members[${index}].postal_address`} component={renderTextField} label="Postal Address" className={classes.textField} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <Field name={`members[${index}].postal_unit`} component={renderTextField} label="Unit # (Optional)" className={classes.textField} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <Field name={`members[${index}].postal_suburb`} component={renderTextField} label="Suburb" className={classes.textField} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <Field
                                    name={`members[${index}].postal_state`}
                                    component={renderSelectField}
                                    label="State"
                                    classes={classes}
                                >
                                        { this.getStates().map((state, index) => {return (<MenuItem key={ index } value={state}>{state}</MenuItem>)}) }
                                </Field>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <Field name={`members[${index}].postal_postcode`} component={renderTextField} label="Postcode" className={classes.textField} />
                            </Grid>
                        </Grid>
                    }

                </div>
            ))
        )
    }

    handleSaveAndContinue() {

        const { createFundRequest, fundFormData, initialValues, updateFund } = this.props
        const { pathname } = this.props.location

        if (initialValues.id) {
            updateFund(fundFormData)
        }
        else {
            if (pathname === '/create_fund') {
                fundFormData['fund_origin'] = 'NEW'
            }
            else {
                fundFormData['fund_origin'] = 'EXISTING'
            }
            
            createFundRequest(fundFormData)
        }
    }

    renderFundAccountFields() {

        const { classes, fundFormData, activeStep, initialValues } = this.props

        return (
            <div className={classes.gridroot}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={4}>
                        <Field name="first_name" component={renderTextField} label="First Name" className={classes.textField} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Field name="last_name" component={renderTextField} label="Last Name" className={classes.textField} />
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={4}>
                        <Field name="email" component={renderTextField} label="Email" className={classes.textField} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Field name="phone" component={renderTextField} label="Phone" className={classes.textField} />
                    </Grid>
                </Grid>
            </div>
        )
    }

    renderFundStructureFields() {
        
        const { classes, fundFormData } = this.props
        const states = this.getStates()
        const fundTypes = this.getFundTypes()

        return (

            <div className={classes.gridroot}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={4}>

                        <Field
                            name="fund_type"
                            component={renderSelectField}
                            label="Trustee Type"
                            classes={classes}
                            onChange={ this.handleFundTypeChange }
                        >
                            { fundTypes.map((type, index) => {
                                return (
                                    <MenuItem key={index} value={type}>{type}</MenuItem>
                                )
                            })}
                        </Field>

                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Field name="fund_name" component={renderTextField} label="Name of SMSF" className={classes.textField} />
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={4}>

                        <Field
                            name="jurisdiction"
                            component={renderSelectField}
                            label="Jurisdiction"
                            classes={classes}
                        >
                            { states.map((state, index) => {
                                return (
                                    <MenuItem key={ index } value={ state }>{ state }</MenuItem>
                                )
                            })}
                        </Field>

                    </Grid>

                    { fundFormData.fund_origin === 'EXISTING' &&
                        <Grid item xs={12} sm={6} md={4}>
                            <Field name="abn" component={renderTextField} label="Fund ABN" className={classes.textField} onChange={this.handleChange('abn')} />
                        </Grid>
                    }
                </Grid>

                { fundFormData.fund_type === 'Corporate' && fundFormData.fund_origin === 'NEW' &&
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Field name="company_name" component={renderTextField} label="Preferred Company Name" className={classes.textField} onChange={this.handleChange('companyName')} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                id="company-name-actual"
                                label="ASIC Registered Name"
                                className={classes.textField}
                                value={ fundFormData.company_name ? fundFormData.company_name.toUpperCase() + ' PTY LTD' : '' }
                                margin="dense"
                                InputProps={{
                                    readOnly: true,
                                }}
                            />
                        </Grid>
                    </Grid>
                }

                { fundFormData.fund_type === 'Corporate' && fundFormData.fund_origin === 'EXISTING' &&
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4}>
                            <Field name="acn" component={renderTextField} label="Trustee ACN" className={classes.textField} onChange={this.handleChange('acn')} />
                        </Grid>
                    </Grid>
                }
            </div>
        )
    }
}

FundAdd = reduxForm({
  form: 'fundForm', // a unique identifier for this form
  enableReinitialize: true
})(FundAdd)

// define the prop types
FundAdd.propTypes = {
    classes: PropTypes.object.isRequired,
    isSubmitting: PropTypes.bool,
    fundsSummaryData: PropTypes.object,
}

const mapStateToPros = (state) => {
    
    const rawFormData = state.form.fundForm
    const fundFormData = (state.form.fundForm) ? state.form.fundForm.values : {}
    const fundFormErrors = (state.form.fundForm) ? (state.form.fundForm.submitErrors ? state.form.fundForm.submitErrors : {}) : {}

    return {
        rawFormData: rawFormData,
        fundFormData: fundFormData,
        fundFormErrors: fundFormErrors,
        initialValues: state.fundState.data,
        isSubmitting: state.fundState.isSubmitting,
        activeStep: state.fundState.activeStep,
        fundStatus: state.fundState.fundStatus,
        fundsSummaryData: state.fundsSummaryState.fundsSummaryData,
    }
}

const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        createFundRequest: action.createFundRequest,
        updateFund: action.updateFund,
        setActiveStep: action.setActiveStep,
        fetchInProgressFund: action.fetchInProgressFund,
        clearFundForm: action.clearFundForm,
    }
}

export default compose(
    connect(mapStateToPros,mapDispatchToProps),
    withStyles(styles)
)(FundAdd)


// WEBPACK FOOTER //
// ./src/components/FundAdd/index.js